/* GIST LIBRARY — Collection landing (gxl-*).
   Library facet filter (N groups, AND-combined; ARIA tablist + roving tabindex + keys),
   optional "shortest first" sort, path-spine draw on reveal, sticky-CTA reveal.
   Dependency-free. Idempotent via data-gxl-init + window.__gxlLoaded.
   Re-inits on shopify:section:load. Picker/tilt/player a11y come from gist-focus.js. */
(function () {
  'use strict';
  if (window.__gxlLoaded) return;
  window.__gxlLoaded = true;

  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var uid = 0;

  function once(el) {
    if (el.hasAttribute('data-gxl-init')) return false;
    el.setAttribute('data-gxl-init', '1');
    return true;
  }

  /* ---------- Library: multi-facet AND filter + sort ---------- */
  function initLibrary(root) {
    (root || document).querySelectorAll('.gxl-library').forEach(function (lib) {
      if (!once(lib)) return;
      var grid = lib.querySelector('.gxl-grid');
      var slots = Array.prototype.slice.call(lib.querySelectorAll('.gxl-slot'));
      var groups = Array.prototype.slice.call(lib.querySelectorAll('.gxl-facet'));
      var status = lib.querySelector('.gxl-status');
      if (!grid || !slots.length || !groups.length) return;
      lib.classList.add('gxl-js');

      var state = {}; // facetName -> selected value ('' = all)

      function apply() {
        var shown = 0;
        slots.forEach(function (slot) {
          var ok = true;
          for (var f in state) {
            var want = state[f];
            if (!want) continue;
            var have = (slot.getAttribute('data-' + f) || '').split(' ');
            if (have.indexOf(want) === -1) { ok = false; break; }
          }
          slot.hidden = !ok;
          if (ok) shown++;
        });
        if (status) status.textContent = shown === slots.length
          ? ('Showing all ' + slots.length)
          : ('Showing ' + shown + ' of ' + slots.length + (shown ? '' : ' — try clearing a filter'));
      }

      groups.forEach(function (group) {
        var facet = group.getAttribute('data-facet');
        var pills = Array.prototype.slice.call(group.querySelectorAll('.gxl-pill'));
        if (!pills.length) return;
        state[facet] = '';
        var gid = 'gxl' + (++uid);
        group.setAttribute('role', 'tablist');
        pills.forEach(function (pill, i) {
          pill.setAttribute('role', 'tab');
          pill.id = gid + '-t' + i;
          pill.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          pill.tabIndex = i === 0 ? 0 : -1;
        });
        function select(idx, focus) {
          pills.forEach(function (p, i) {
            var on = i === idx;
            p.setAttribute('aria-selected', on ? 'true' : 'false');
            p.tabIndex = on ? 0 : -1;
          });
          state[facet] = pills[idx].getAttribute('data-val') || '';
          if (focus) pills[idx].focus();
          apply();
        }
        pills.forEach(function (pill, i) {
          pill.addEventListener('click', function () { select(i, false); });
          pill.addEventListener('keydown', function (ev) {
            var to = null;
            if (ev.key === 'ArrowRight' || ev.key === 'ArrowDown') to = (i + 1) % pills.length;
            if (ev.key === 'ArrowLeft' || ev.key === 'ArrowUp') to = (i - 1 + pills.length) % pills.length;
            if (ev.key === 'Home') to = 0;
            if (ev.key === 'End') to = pills.length - 1;
            if (to === null) return;
            ev.preventDefault();
            select(to, true);
          });
        });
      });

      var sortBtn = lib.querySelector('.gxl-sort');
      if (sortBtn) {
        var sorted = false;
        var original = slots.slice();
        sortBtn.addEventListener('click', function () {
          sorted = !sorted;
          sortBtn.setAttribute('aria-pressed', sorted ? 'true' : 'false');
          var order = sorted
            ? slots.slice().sort(function (a, b) {
                return (parseInt(a.getAttribute('data-duration'), 10) || 9999) -
                       (parseInt(b.getAttribute('data-duration'), 10) || 9999);
              })
            : original;
          order.forEach(function (s) { grid.appendChild(s); });
        });
      }
      apply();
    });
  }

  /* ---------- Path: draw the spine when it scrolls in ---------- */
  function initSpine(root) {
    (root || document).querySelectorAll('.gxl-spine').forEach(function (spine) {
      if (!once(spine)) return;
      if (mqReduce.matches || !('IntersectionObserver' in window)) { spine.classList.add('is-drawn'); return; }
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) { if (e.isIntersecting) { spine.classList.add('is-drawn'); obs.disconnect(); } });
      }, { threshold: 0.2 });
      io.observe(spine);
    });
  }

  /* ---------- Sticky CTA: show after the hero, hide near pricing/footer ---------- */
  function initSticky(root) {
    (root || document).querySelectorAll('.gxl-sticky').forEach(function (bar) {
      if (!once(bar)) return;
      if (!('IntersectionObserver' in window)) return;
      var hero = document.getElementById('gxl-hero');
      var pricing = document.getElementById('gist-pricing') ||
                    document.querySelector('.gx-pricing, [id*="pricing"]');
      var pastHero = false, atPricing = false;
      function update() { bar.classList.toggle('is-in', pastHero && !atPricing); }
      if (hero) {
        new IntersectionObserver(function (e) { pastHero = !e[0].isIntersecting; update(); },
          { rootMargin: '-40% 0px 0px 0px' }).observe(hero);
      } else { pastHero = true; }
      if (pricing) {
        new IntersectionObserver(function (e) { atPricing = e[0].isIntersecting; update(); },
          { threshold: 0.05 }).observe(pricing);
      }
    });
  }

  function initAll(root) { initLibrary(root); initSpine(root); initSticky(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else { initAll(document); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
